export default "__VITE_ASSET__BBtRPH$z__"